import { Switch } from 'react-router-dom'
import SignIn from '../pages'
import ForgotPassword from '../pages/Auth/forgot-password'
import TokenPassword from '../pages/Auth/token-password'
import { Clients } from '../pages/clients'
import ClientsCreateOrUpdate from '../pages/clients/form'
import ConfigurationForm from '../pages/configurations'
import Dashboard from '../pages/dashboard/dashboard'
import { Demands } from '../pages/demand'
import DemandsCreateOrUpdate from '../pages/demand/form'
import { SeviceOrder } from '../pages/demand/service_order'
import { ServiceOrderList } from '../pages/demand/service_order/list'
import { Employees } from '../pages/employees'
import EmployeesCreateOrUpdate from '../pages/employees/form'
import Financial from '../pages/financial'
import Forbidden from '../pages/forbidden'
import OpenAccounts from '../pages/open-accounts'
import PaymentConditions from '../pages/payment-conditions'
import PaymentConditionForm from '../pages/payment-conditions/form'
import PaymentMethods from '../pages/payment-methods'
import PaymentMethodForm from '../pages/payment-methods/form'
import { Prodivders } from '../pages/providers'
import ProviderCreateOrUpdate from '../pages/providers/form'
import { RawMaterials } from '../pages/raw-material'
import RawMaterialCreateOrUpdade from '../pages/raw-material/form'
import StockManagement from '../pages/stock/StockManagement'
import UserProfile from '../pages/user-profile'
import { Users } from '../pages/users'
import UsersCreateOrUpdate from '../pages/users/form'
import Route from './Route'

type AppRoute = {
  path: string
  exact?: boolean
  component: React.ComponentType<any>
  requiredPermissions?: string[]
  isPublic?: boolean
}

export const routesConfig: AppRoute[] = [
  { path: '/', exact: true, component: SignIn, isPublic: true },
  { path: '/forgot-password', exact: true, component: ForgotPassword, isPublic: true },
  { path: '/token-password', exact: true, component: TokenPassword, isPublic: true },
  { path: '/forbidden', exact: true, component: Forbidden, isPublic: true },
  { path: '/dashboard', exact: true, component: Dashboard, requiredPermissions: ['dashboard.view'] },
  { path: '/user-profile/:id', exact: true, component: UserProfile },
  { path: '/users', exact: true, component: Users, requiredPermissions: ['users.manage'] },
  { path: '/users/create', exact: true, component: UsersCreateOrUpdate, requiredPermissions: ['users.manage'] },
  { path: '/users/edit/:id', exact: true, component: UsersCreateOrUpdate, requiredPermissions: ['users.manage'] },
  { path: '/providers', exact: true, component: Prodivders, requiredPermissions: ['providers.manage'] },
  {
    path: '/providers/create',
    exact: true,
    component: ProviderCreateOrUpdate,
    requiredPermissions: ['providers.manage'],
  },
  {
    path: '/providers/edit/:id',
    exact: true,
    component: ProviderCreateOrUpdate,
    requiredPermissions: ['providers.manage'],
  },
  { path: '/raw-materials', exact: true, component: RawMaterials, requiredPermissions: ['raw_materials.manage'] },
  {
    path: '/raw-materials/create',
    exact: true,
    component: RawMaterialCreateOrUpdade,
    requiredPermissions: ['raw_materials.manage'],
  },
  {
    path: '/raw-materials/edit/:id',
    exact: true,
    component: RawMaterialCreateOrUpdade,
    requiredPermissions: ['raw_materials.manage'],
  },
  { path: '/clients', exact: true, component: Clients, requiredPermissions: ['clients.manage'] },
  {
    path: '/clients/create',
    exact: true,
    component: ClientsCreateOrUpdate,
    requiredPermissions: ['clients.manage'],
  },
  {
    path: '/clients/edit/:id',
    exact: true,
    component: ClientsCreateOrUpdate,
    requiredPermissions: ['clients.manage'],
  },
  { path: '/employees', exact: true, component: Employees, requiredPermissions: ['employees.manage'] },
  {
    path: '/employees/create',
    exact: true,
    component: EmployeesCreateOrUpdate,
    requiredPermissions: ['employees.manage'],
  },
  {
    path: '/employees/edit/:id',
    exact: true,
    component: EmployeesCreateOrUpdate,
    requiredPermissions: ['employees.manage'],
  },
  { path: '/demands', exact: true, component: Demands, requiredPermissions: ['demands.manage'] },
  {
    path: '/demands/create',
    exact: true,
    component: DemandsCreateOrUpdate,
    requiredPermissions: ['demands.manage'],
  },
  {
    path: '/demands/edit/:id',
    exact: true,
    component: DemandsCreateOrUpdate,
    requiredPermissions: ['demands.manage'],
  },
  {
    path: '/demands/:id/services_order',
    exact: true,
    component: SeviceOrder,
    requiredPermissions: ['demands.manage'],
  },
  {
    path: '/demands/:demandId/services_order/:id',
    exact: true,
    component: ServiceOrderList,
    requiredPermissions: ['demands.manage'],
  },
  {
    path: '/configurations',
    exact: true,
    component: ConfigurationForm,
    requiredPermissions: ['configurations.manage'],
  },
  { path: '/stock-management', exact: true, component: StockManagement, requiredPermissions: ['stock.manage'] },
  { path: '/financial', exact: true, component: Financial, requiredPermissions: ['financial.manage'] },
  { path: '/payment-methods', exact: true, component: PaymentMethods, requiredPermissions: ['financial.manage'] },
  {
    path: '/payment-methods/create',
    exact: true,
    component: PaymentMethodForm,
    requiredPermissions: ['financial.manage'],
  },
  {
    path: '/payment-methods/edit/:id',
    exact: true,
    component: PaymentMethodForm,
    requiredPermissions: ['financial.manage'],
  },
  {
    path: '/payment-conditions',
    exact: true,
    component: PaymentConditions,
    requiredPermissions: ['financial.manage'],
  },
  {
    path: '/payment-conditions/create',
    exact: true,
    component: PaymentConditionForm,
    requiredPermissions: ['financial.manage'],
  },
  {
    path: '/payment-conditions/edit/:id',
    exact: true,
    component: PaymentConditionForm,
    requiredPermissions: ['financial.manage'],
  },
  {
    path: '/open-accounts',
    exact: true,
    component: OpenAccounts,
    requiredPermissions: ['financial.manage'],
  },
]

export default function Routes() {
  return (
    <Switch>
      {routesConfig.map(({ path, component, exact, requiredPermissions, isPublic }) => (
        <Route
          key={path}
          exact={exact}
          path={path}
          component={component}
          requiredPermissions={requiredPermissions}
          isPublic={isPublic}
        />
      ))}
    </Switch>
  )
}
